<!-- Add overlay div at the top -->
@if (showHoverSidebox || showHelpSidebox || showAboutCertificateMenu) {
  <div class="sidebar-overlay"
    (mouseenter)="onOverlayMouseEnter()">
  </div>
}

<div class="sidebar"
  [class.collapsed]="!isExpanded"
  [class.expanded]="isExpanded"
  data-tour="sidebar">
  <div class="sidebar-content">
    <!-- Main menu items - in scrollable area -->
    <div class="main-menu-items">
      @for (item of menuItems; track item) {
        <div class="menu-item" (mouseenter)="onMenuItemHover($event, item)"
          (mouseleave)="onMenuItemLeave($event)"
          [class.active]="item.active">
          <a [routerLink]="item.route"
            class="menu-link"
            [class.active]="item.active"
            (click)="navigateToRoute(item.route)">
            <div class="icon-wrapper">
              <i class="fas fa-{{item.icon}}"></i>
            </div>
            <span class="menu-text" [class.visible]="isExpanded || hoveredMenuItem === item">{{item.label}}</span>
            <div class="active-indicator"></div>
          </a>
        </div>
      }
    </div>

    <!-- Help menu item at absolute bottom -->
    <div class="help-section">
      <div class="menu-item help-menu-item"
        [class.active]="helpMenuItem.active"
        (mouseenter)="onHelpIconHover($event)"
        (mouseleave)="onHelpIconLeave($event)">
        <a class="menu-link"
          [class.active]="helpMenuItem.active">
          <div class="icon-wrapper">
            <i class="fas fa-{{helpMenuItem.icon}}"></i>
          </div>
          <span class="menu-text" [class.visible]="isExpanded">{{helpMenuItem.label}}</span>
          <div class="active-indicator"></div>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Hover Sidebox for main menu items -->
@if (showHoverSidebox && hoveredMenuItem) {
  <div class="hover-sidebox" style="margin-top: 15px;"
    [style.left.px]="sidebarLeftPosition"
    [style.top.px]="sidebarTopPosition"
    (mouseenter)="onSideboxMouseEnter()"
    (mouseleave)="onSideboxMouseLeave($event)">
    <div class="sidebox-content">
      @if (hoverTabs.length > 0) {
        <div class="sidebox-tabs">
          @for (tab of hoverTabs; track tab) {
            <div
              class="sidebox-tab-item"
              [class.active]="tab.active"
              (click)="navigateToTab(tab)"
              (mouseenter)="onSideboxTabHover()">
              @if (tab.icon) {
                <i class="fas fa-{{tab.icon}}"></i>
              }
              <span>{{tab.label}}</span>
            </div>
          }
        </div>
      }
      @if (hoverTabs.length === 0) {
        <div class="no-tabs-message">
          No options available
        </div>
      }
    </div>
  </div>
}

<!-- Help Sidebox -->
@if (showHelpSidebox) {
  <div class="hover-sidebox help-sidebox"
    [style.left.px]="helpSideboxLeftPosition"
    [style.top.px]="helpSideboxTopPosition"
    (mouseenter)="onHelpSideboxMouseEnter()"
    (mouseleave)="onHelpSideboxMouseLeave($event)">
    <div class="sidebox-content">
      <div class="sidebox-tabs">
        @for (tab of visibleHelpTabs; track tab) {
          <div
            class="sidebox-tab-item"
            [class.active]="tab.active"
            (mouseenter)="tab.hasNestedMenu ? onAboutCertificateHover($event, tab) : null"
            (mouseleave)="tab.hasNestedMenu ? onAboutCertificateLeave($event) : null"
            (click)="navigateToHelpTab(tab)">
            @if (tab.icon) {
              <i class="fas fa-{{tab.icon}}"></i>
            }
            <span>{{tab.label}}</span>
            @if (tab.hasNestedMenu) {
              <i class="fas fa-chevron-right nested-arrow"></i>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Nested Sidebox for About Certificate -->
@if (showAboutCertificateMenu) {
  <div class="hover-sidebox nested-sidebox"
    [style.left.px]="nestedMenuLeftPosition"
    [style.top.px]="nestedMenuTopPosition"
    (mouseenter)="onNestedMenuMouseEnter()"
    (mouseleave)="onNestedMenuMouseLeave($event)">
    <div class="sidebox-content">
      <div class="sidebox-tabs">
        @for (tab of aboutCertificateTabs; track tab) {
          <div
            class="sidebox-tab-item"
            [class.active]="tab.active"
            (click)="navigateToNestedTab(tab)">
            @if (tab.icon) {
              <i class="fas fa-{{tab.icon}}"></i>
            }
            <span>{{tab.label}}</span>
          </div>
        }
      </div>
    </div>
  </div>
}